import { DEFAULT_PAGE_SIZE, PageRequest } from '@/app/core/models/paged-result.model';
import {
  PendingBonus,
  PendingBonusDetail,
  PendingBonusFilters,
  PendingBonusResult,
} from '../models/pending-bonus.model';
import { toPageMeta } from './page-meta.api';
import { IssuedPayroll } from '../models/issued-payroll.model';
import {
  IssuedPayrollApiResponse,
  PendingBonusApiItem,
  PendingBonusApiResponse,
  PendingBonusDetailApiResponse,
} from './pending-bonus-api.types';

export function toApiQueryParams(
  filters: PendingBonusFilters,
  page: PageRequest,
): Record<string, string | number> {
  const isDefault = page.page === 0 && page.size === DEFAULT_PAGE_SIZE;
  return isDefault ? { ...filters } : { ...filters, page: page.page, size: page.size };
}

export function toPendingBonus(item: PendingBonusApiItem): PendingBonus {
  return {
    folio: item.folio,
    accountNumber: item.accountNumber,
    affiliateRut: item.affiliateRut.toLowerCase(),
    patientRut: item.patientRut.toLowerCase(),
    patientName: item.patientName,
    billedAmount: item.billedAmount,
  };
}

export function toPendingBonusResult(response: PendingBonusApiResponse): PendingBonusResult {
  return {
    records: response.data.map(toPendingBonus),
    page: response.meta ? toPageMeta(response.meta) : null,
  };
}

export function toPendingBonusDetail(response: PendingBonusDetailApiResponse): PendingBonusDetail {
  const item = response.data;
  return {
    ...toPendingBonus(item),
    service: item.service,
    coveredAmount: item.coveredAmount,
    treatingPhysician: item.treatingPhysician,
    billerRut: item.billerRut,
  };
}

export function toIssuedPayroll(response: IssuedPayrollApiResponse): IssuedPayroll {
  return { ...response.data };
}
